/**
 * Generates fingerprint based on error object
 * @param {Error} error
 * @return {String}
 */
export default (error) => {
  const name = error.name || ''
  const message = error.message || ''
  const level = error.level || ''
  const hashBase = level + name + message

  if (!name && !message) {
    return null
  }

  return hashBase
}



// WEBPACK FOOTER //
// ./common/utils/rollbar/fingerprint.js